import { Resource } from './resource';
import gql from 'graphql-tag';

export class AbsenceResource extends Resource {
  public static async list(extraFields: string[] = []) {
    return await this.query(
      {
        query: gql`
            query {
              absence {
                id
                name
                ${extraFields.join('\n')}
              }
            }
          `
      },
      'absence'
    );
  }

  public static async add(absence: any) {
    return await this.mutation(
      {
        mutation: gql`
          mutation($absence: AbsenceInput!) {
            addAbsence(absence: $absence) {
              id
              code
              name
              isWorktime
              displayAsWorktime
              isPaid
              isHoliday
            }
          }
        `,
        variables: { absence },
        refetchQueries: [
          {
            query: gql`
              query {
                absence {
                  id
                  code
                  name
                  isWorktime
                  displayAsWorktime
                  isPaid
                  isHoliday
                }
              }
            `
          }
        ]
      },
      'addAbsence'
    );
  }

  public static async update(id: number, absence: any) {
    await this.mutation({
      mutation: gql`
        mutation($id: Int!, $absence: AbsenceInput!) {
          editAbsence(id: $id, absence: $absence) {
            id
            code
            name
            isWorktime
            displayAsWorktime
            isPaid
            isHoliday
          }
        }
      `,
      variables: { id, absence }
    });
  }

  public static async delete(id: number) {
    return this.mutation({
      mutation: gql`
        mutation($id: Int!) {
          removeAbsence(id: $id)
        }
      `,
      variables: { id },
      refetchQueries: [
        {
          query: gql`
            query {
              absence {
                id
                code
                name
                isWorktime
                displayAsWorktime
                isPaid
                isHoliday
              }
            }
          `
        }
      ]
    });
  }
}
